// src/components/Sidebar.jsx
import React from 'react';
import './Project.css';

export default function Sidebar({ menuItems, onSelect, activeId }) {
  return (
    <>
      {/* PC 端 Sidebar */}
      <nav className="sidebar desktop-only">
        <ul>
          {menuItems.map(item => (
            <li key={item.id}>
              <button
                className={activeId === item.id ? 'active' : ''}
                onClick={() => onSelect(item.id)}
              >
                {item.title}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* 移动端下拉 */}
      <div className="sidebar-select mobile-only">
        <select
          value={activeId}
          onChange={(e) => onSelect(e.target.value)}
        >
          {menuItems.map(item => (
            <option key={item.id} value={item.id}>
              {item.title}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
